import React from 'react'
import './blog.scss'

const Blog = () => {
  return (
    <div>Blog</div>
  )
}

export default Blog